import { LOAD_OUTLETS } from './type'
import { firestore } from '../utils/firebase'
import { getLocation } from './metaAction'

export const loadOutlets = () => dispatch => {
    firestore.collection('outlets').get().then(snapshot => {
        const outlets = {}
        snapshot.forEach(doc => {
            outlets[doc.id] = {
                id: doc.id,
                ...doc.data()
            }
        })
        dispatch({
            type: LOAD_OUTLETS,
            payload: outlets
        })
        dispatch(getLocation())
    }).catch(e => {
        console.log(e);
    })
}